import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { NavLink, useNavigate } from "react-router-dom";
import { ReactComponent as LogoSVG } from '../src/images/logostartedge.svg';
import englishServices from "./data/SdataEN";
import frenchServices from "./data/SdataFR";

const Navbar = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const [services, setServices] = useState(
    i18n.language === "fr" ? frenchServices : englishServices
  );

  useEffect(() => {
    setServices(i18n.language === "fr" ? frenchServices : englishServices);
  }, [i18n.language]);

/*   const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'fr' : 'en';
    i18n.changeLanguage(newLang);
  }; */

  const handleServiceClick = (detailData) => {
    navigate("/service-details", {
      state: detailData,
    });
  };

  return (
    <div className="container-fluid nav_bg mb-0 pb-0">
      <div className="row">
        <div className="col-12">
          <nav className="navbar navbar-expand-lg navbar-light blue-color-code bg-light">
            <div className="container-fluid px-3">

              {/* Logo */}
              <NavLink className="navbar-brand d-flex align-items-center" to="/">
                <LogoSVG style={{ height: "100px", width: "150px" }} alt="Logo" />
              </NavLink>

              {/* Hamburger Toggler */}
              <button
                className="navbar-toggler ms-auto"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>

              {/* Navbar Items */}
              <div className="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
                <ul className="navbar-nav mb-2 mb-lg-0">
                  <li className="nav-item">
                    <NavLink to="/" end className="nav-link">
                      {t("home")}
                    </NavLink>
                  </li>

                  {/* Dynamic Services Dropdown */}
                  <li className="nav-item dropdown">
                    <button
                      className="nav-link dropdown-toggle btn btn-link"
                      id="serviceDropdown"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {t("service")}
                    </button>
                    <ul className="dropdown-menu" aria-labelledby="serviceDropdown">
                      {services.map((service, index) => (
                        <li key={index}>
                          <button
                            className="dropdown-item"
                            onClick={() => handleServiceClick(service.detailData)}
                          >
                            {service.title}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </li>

                  <li className="nav-item">
                    <NavLink to="/team" className="nav-link">
                      {t("team")}
                    </NavLink>
                  </li>

                  <li className="nav-item">
                    <NavLink to="/contact" className="nav-link">
                      {t("contact")}
                    </NavLink>
                  </li>

                  {/* Optional: Language Toggle Button */}
                  {/* 
                  <li className="nav-item">
                    <button onClick={toggleLanguage} className="btn btn-outline-secondary ms-3">
                      {i18n.language === 'en' ? 'FR' : 'EN'}
                    </button>
                  </li> 
                  */}
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
